var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoSixt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "10px",
    viewBox: "0 0 24 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2F57A415-AC8B-484A-A973-6104E6C836EF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.8161053,15.7471334 L13.120056,12.3543381 L12.0394039,10.9507031 C12.9421882,10.7037119 13.7619313,10.3215557 14.4764845,9.76682466 L15.1724111,10.6410491 L16.4933134,8.66213117 L24,8.66213117 L24,10.9081555 L22.3118811,10.9081555 L22.3118811,16.3921648 L16.4933134,16.3921648 L15.004263,14.186371 L13.4564538,16.3921648 L7.98329243,16.3921648 L7.98329243,14.8839908 C7.589897,15.9505359 6.3480056,16.6 3.88559269,16.6 C0.233002804,16.6 0.0559477663,15.319743 0,13.8534786 L2.88855743,13.8534786 C2.89787077,14.2911114 2.97244522,14.6085227 3.14950025,14.8163243 C3.33583476,15.0243611 3.58746425,15.1337357 3.96016713,15.1337357 C4.54707681,15.1337357 5.18072252,14.9696906 5.18072252,14.3349015 C5.18072252,14.1926507 5.13422356,14.0723957 5.05964911,13.9739351 C4.67766675,13.4707179 1.46287153,13.0986697 0.559003529,12.1684987 C0.195613982,11.7964169 0.083853916,11.2385292 0.083853916,10.789781 C0.083853916,9.06101095 1.43496538,8.28420618 4.12790883,8.28420618 C6.98839078,8.28420618 7.66552131,9.27700647 7.70291014,10.9073159 L4.92126983,10.9073159 C4.90267702,10.4696832 4.77039374,10.1277911 4.57643923,9.96918613 C4.38905485,9.8158535 4.22656249,9.74482885 3.94137112,9.75026904 C3.3451481,9.76198894 3.02842685,10.0129763 3.02842685,10.4179343 C3.02842685,10.5381892 3.06561247,10.6913204 3.14950025,10.7789007 C3.58746425,11.2712375 6.69957568,11.6214914 7.59413034,12.5623413 C7.73609949,12.7113083 7.88084571,12.905711 7.98329243,13.1755375 L7.98329243,11.3558626 C8.90741271,11.3898134 9.86915888,11.3596237 10.8163085,11.2127723 L10.8161053,15.7471334 Z M18.1201675,10.9142337 L17.0637639,12.3857367 L19.504028,15.926458 L19.504028,10.9142337 L18.1201675,10.9142337 Z M13.048008,7 L15.9932244,7 C15.1075428,9.53932416 12.3459516,11.1302426 7.98266929,10.912568 L7.98266929,8.66214461 C10.8672305,8.87290143 12.490901,8.06338838 13.048008,7 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "01-Sixtbook_dashboard",
    transform: "translate(-22.000000, -155.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_sixt",
    transform: "translate(22.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Fill-3-Copy",
    fill: "#ffffff",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoSixt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_sixt.d2fd1866dc72c6727848821104a92d57.svg";